import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  card: {
    borderRadius: "3%",
    width: "95%",
    height: "30vh",
    boxShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.2) !important",
    backgroundColor: ({ theme }) => theme.palette.bgColor,
    minHeight: "280px",
  },
  cardContent: {
    padding: 0,
    marginTop: "0%",
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },

  iconbtn: {
    border: "solid 2px rgba(168, 171, 194, 1)",
    padding: "4px",
    borderRadius: "5px",
    marginTop: "8px",
    marginRight: "8px",
    transition: "transform 0.1",
    "&:active": {
      transform: ({ loading }) => (loading ? "" : "scale(0.85)"),
    },
  },
  favorated: {
    color: "rgb(184, 3, 81)",
  },
  name: {
    textAlign: "start",
    fontWeight: 700,
    fontSize: "1vw",
    color: ({ theme }) => theme.palette.text.primary,
    fontFamily: "Rubik",
    marginBottom: "5px",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
  },
  type: {
    textAlign: "start",
    fontWeight: 500,
    fontSize: "0.8vw",
    color: ({ theme }) => theme.palette.text.primary,
    fontFamily: "Rubik",
    lineHeight: "15px",
  },
  break: {
    margin: "0 16px 12px 16px",
    color: "#A8ABC2",
    borderWidth: "1.5px",
  },
  link: {
    fontWeight: "600px",
    fontSize: "0.7vw",
    height: "2vw",
    fontFamily: "Rubik",
    textAlign: "center",
    color: "#FFFFFF",
    backgroundColor: "#B80351",
    "&:hover": {
      backgroundColor: "#B80351",
    },
  },

  grid: {
    padding: "0 16px 0 16px",
    marginBottom: 0,
    height: "10vh",
    minHeight: "85px",
  },
  content: {
    backgroundColor: "#FFFFFF",
    width: "85%",
    height: "80%",
    paddingRight: "5px",
  },
  productImg: {
    height: "100%",
    width: "100%",
    objectFit: "contain",
  },
  nameWrapper: {
    paddingLeft: "10%",
  },

  pagination: {
    display: "flex",
    marginBottom: "10px",
    marginTop: "10px",
    justifyContent: "space-between",
    width: ({ isNavbarOpen, count }) =>
      `calc(100% - ${(isNavbarOpen ? 53 : 47) - count * 0.5}%)`,
    "@media (min-height: 1050px)": {
      marginTop: "2rem",
    },
  },

  pageText: {
    fontSize: "0.8vw",
    fontWeight: 400,
    lineHeight: "13px",
    marginRight: "7%",
    width: "15%",
    color: ({ theme }) => theme.palette.text.primary,
  },
});
